import { NavItemProps } from '@portal/frontend/react';
import { AppRoutes } from '@portal/frontend/utils';

export const NAV_ITEMS: NavItemProps[] = [
  {
    path: AppRoutes.REPORT,
    title: 'Report',
  },
];
